// Copy de los rechazos por la cadena elegida (`retailerId`) en las promos.
import { ApiError } from '@/api/errors';

export const RETAILER_REQUIRED_MESSAGE = 'Elige una cadena para ver y editar sus promos.';
export const RETAILER_NOT_FOUND_MESSAGE = 'No encontramos esa cadena. Elige otra de la lista.';

const RETAILER_ERROR_MESSAGES: Record<string, string> = {
    RETAILER_REQUIRED: RETAILER_REQUIRED_MESSAGE,
    RETAILER_NOT_FOUND: RETAILER_NOT_FOUND_MESSAGE,
};

/** Mensaje si el error es por la cadena; `undefined` si es otro. */
export function retailerScopeErrorCopy(error: unknown): string | undefined {
    if (!(error instanceof ApiError)) return undefined;
    return Object.hasOwn(RETAILER_ERROR_MESSAGES, error.code)
        ? RETAILER_ERROR_MESSAGES[error.code]
        : undefined;
}
